/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailssettingstitle2Inputs */

const en_emailssettingstitle2 = /** @type {(inputs: Emailssettingstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mails`)
};

const de_emailssettingstitle2 = /** @type {(inputs: Emailssettingstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mails`)
};

/**
* | output |
* | --- |
* | "E-mails" |
*
* @param {Emailssettingstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailssettingstitle2 = /** @type {((inputs?: Emailssettingstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailssettingstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailssettingstitle2(inputs)
	return de_emailssettingstitle2(inputs)
});
export { emailssettingstitle2 as "emailsSettingsTitle" }